import { Translate, useTranslation } from "@privacy/translations";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useMutation } from "@tanstack/react-query";
import { updateDpiaConnectedTenantMutationOptions } from "../../api/dpia";
import * as FormDialog from "../../shared/FormDialog";

type DpiaConnectedTenantWarningDialogProps = {
  dpia: { id: string; name: string };
  tenant: { id: string; name: string };
  onClose: () => void;
};

export const DpiaConnectedTenantWarningDialog = ({ dpia, tenant, onClose }: DpiaConnectedTenantWarningDialogProps) => {
  const { t } = useTranslation();
  const updateConnectedTenantMutation = useMutation(updateDpiaConnectedTenantMutationOptions());

  return (
    <FormDialog.Dialog isOpen={true}>
      <FormDialog.Title>{t("DpiaDrawer.Dialog.ConnectedTenant.Header")}</FormDialog.Title>

      <FormDialog.Form
        onSubmit={() =>
          updateConnectedTenantMutation.mutate(
            { dpiaId: dpia.id, tenantId: tenant.id, tenantName: tenant.name, isConfirm: true },
            { onSuccess: onClose }
          )
        }
      >
        <FormDialog.Content>
          <FormDialog.FormError isError={updateConnectedTenantMutation.isError} />
          <Typography variant="body2">
            <Translate
              translationKey="DpiaDrawer.Dialog.ConnectedTenant.Message"
              values={{
                dpiaName: (
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    {dpia.name}
                  </Box>
                ),
                tenantName: (
                  <Box component="span" sx={{ fontWeight: "bold" }}>
                    {tenant.name}
                  </Box>
                ),
              }}
            />
          </Typography>
          <Stack component="ul" sx={{ gap: 1, pl: 3, mt: 3, mb: 0 }}>
            <Typography variant="body2" component="li">
              {t("DpiaDrawer.Dialog.ConnectedTenant.ResponsibleBecomesCollaborator")}
            </Typography>
            <Typography variant="body2" component="li">
              {t("DpiaDrawer.Dialog.ConnectedTenant.YouBecomeResponsible")}
            </Typography>
            <Typography variant="body2" component="li">
              {t("DpiaDrawer.Dialog.ConnectedTenant.DelegateAfterwards")}
            </Typography>
          </Stack>
        </FormDialog.Content>
        <FormDialog.ActionButtons>
          <FormDialog.CancelButton onClick={onClose} />
          <FormDialog.SubmitButton isSubmitting={updateConnectedTenantMutation.isPending}>
            {t("DpiaDrawer.Dialog.ConnectedTenant.Button")}
          </FormDialog.SubmitButton>
        </FormDialog.ActionButtons>
      </FormDialog.Form>
    </FormDialog.Dialog>
  );
};
